/**
 * Referral.tsx · 09_APP · OS-006 · 2026-10-20 · C47, v67
 *
 * Her words: "how do we start keeping track of everybody who we refer who comes to us and we refer to the right
 * services for them because they should count in our numbers". Acceptance test: a call-in referral logged on her
 * phone in under 30 seconds. So: one tap on the agency, an optional first name, Save. Nothing else is required.
 * On a profile the name is already known, so it is one tap and Save.
 */

import { useState } from "react";
import { os, type Impact } from "../lib/os";

export const AGENCIES = [
  "Sacramento Family Justice Center", "WEAVE", "211", "St John's", "The Table / 3Strands",
  "CASH", "My Sister's House",
];

export function ReferralQuick({ personId = null, personName = null, onSaved, onClose }: {
  personId?: string | null; personName?: string | null;
  onSaved?: (impact: Impact, id: string) => void; onClose?: () => void;
}) {
  const [agency, setAgency] = useState<string | null>(null);
  const [other, setOther] = useState("");
  const [caller, setCaller] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [done, setDone] = useState<string | null>(null);

  const chosen = agency === "Other" ? other.trim() : agency;

  async function save() {
    if (!chosen || busy) return;
    setBusy(true); setErr(null);
    try {
      const r = await os.referralLog(chosen, personId, caller, note);
      setDone(`Saved: ${personName ?? (caller.trim() || "a caller")} referred to ${chosen}.`);
      setAgency(null); setOther(""); setCaller(""); setNote("");
      onSaved?.(r.impact, r.id);
    } catch (e) { setErr(e instanceof Error ? e.message : String(e)); }
    finally { setBusy(false); }
  }

  return (
    <div className="ref-quick">
      <div className="ref-head">
        <b>{personName ? `Refer ${personName.split(" ")[0]} to` : "Log a referral"}</b>
        {onClose && <button className="ref-x" aria-label="Close" onClick={onClose}>×</button>}
      </div>
      <div className="ref-chips" role="group" aria-label="Where you referred her">
        {[...AGENCIES, "Other"].map((a) => (
          <button key={a} className={agency === a ? "on" : ""} onClick={() => setAgency(a)}>{a}</button>
        ))}
      </div>
      {agency === "Other" && (
        <input className="ref-in" autoFocus value={other} onChange={(e) => setOther(e.target.value)} placeholder="Where did you refer her?" />
      )}
      {!personId && (
        <input className="ref-in" value={caller} onChange={(e) => setCaller(e.target.value)}
          placeholder="Her first name, if she gave one (optional)" autoCapitalize="words" />
      )}
      <input className="ref-in" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Note (optional)" />
      <button className="ref-save" disabled={!chosen || busy} onClick={() => void save()}>{busy ? "Saving" : "Save referral"}</button>
      {done && <p className="ref-ok" role="status">✓ {done}</p>}
      {err && <p className="ref-err">{err}</p>}
    </div>
  );
}
